import { styled } from 'parkdepot-shared/theme'

export const Wrapper = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    padding: '2.4rem 0',

    [$theme.mediaQuery.large]: {
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        gap: '10px'
    }
}))

export const ButtonContainer = styled('div', ({ $theme }) => ({
    marginTop: '2.4rem'
}))
